/** Como o preço do serviço aparece nas páginas públicas do prestador. */
export enum PRICE_DISPLAY_MODE {
  /** Mostra o valor exato. */
  SHOW = 'show',
  /** Exibe "a partir de R$ X". */
  FROM = 'from',
  /** Não exibe preço. */
  HIDDEN = 'hidden',
}
